// Module 1 — entity constants (frontend mirror of the entities schema rules)

// Status lifecycle: Draft → Active → Suspended → Archived
export const ENTITY_STATUSES = ['draft', 'active', 'suspended', 'archived'];

export const STATUS_META = {
    draft:     { label: 'Draft',     pill: 'bg-gray-100 text-gray-700 border-gray-300' },
    active:    { label: 'Active',    pill: 'bg-green-100 text-green-800 border-green-300' },
    suspended: { label: 'Suspended', pill: 'bg-amber-100 text-amber-800 border-amber-300' },
    archived:  { label: 'Archived',  pill: 'bg-slate-200 text-slate-700 border-slate-400' }
};

// Operator vocabulary for what KIND of compartment this is (display_label).
// Free-form per BL-088, but these are the common ones offered as suggestions.
export const DISPLAY_LABELS = ['Brand', 'Hub', 'Practice', 'Location', 'Client'];

export function statusMeta(status) {
    return STATUS_META[status] || { label: status || '—', pill: 'bg-gray-100 text-gray-700 border-gray-300' };
}
